import { render, staticRenderFns } from "./ClienteCredorHome.vue?vue&type=template&id=18737e21"
import script from "./ClienteCredorHome.vue?vue&type=script&lang=js"
export * from "./ClienteCredorHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports